/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_OverlineInputs */

const en_mk_model_overline = /** @type {(inputs: Mk_Model_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03 · Model Hub`)
};

const id_mk_model_overline = /** @type {(inputs: Mk_Model_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03 · Model Hub`)
};

/**
* | output |
* | --- |
* | "03 · Model Hub" |
*
* @param {Mk_Model_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_overline = /** @type {((inputs?: Mk_Model_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_overline(inputs)
	return en_mk_model_overline(inputs)
});